<div *ngIf="showHelpers">
  <button mat-button (click)="changeBrand('generali')">generali</button>
  <button mat-button (click)="changeBrand('proama')">proama</button>
  <button mat-button (click)="changeBrand('common')">common</button>
</div>
